import { ImageRetry, Icon } from '@openeducation/oe-rn-components';
import Color from 'color';
import React from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import { useColors } from '../../../../../../hooks';

interface AvatarProps {
  color?: string;
  size?: number;
  image?: string;
  style?: StyleProp<ViewStyle>;
}

export default function Avatar({
  color,
  size = 40,
  image,
  style,
}: AvatarProps) {
  const colors = useColors();
  color = color || colors.primary;
  const backgroundColor = Color(color).alpha(0.1).string();

  return (
    <View
      style={[
        styles.content,
        { width: size, height: size, borderRadius: size / 2, backgroundColor },
        style,
      ]}
    >
      {image ? (
        <ImageRetry
          accessibilityIgnoresInvertColors
          style={styles.image}
          source={{ uri: image }}
        />
      ) : (
        <Icon color={color} size={size / 2.5} name="user" type="solid" />
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  content: {
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  image: {
    flex: 1,
    width: '100%',
    height: '100%',
  },
});
